// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__Hhwqg","title":"Info_title__2Etjr","selects":"Info_selects__3szzN","requiredAsterisk":"Info_requiredAsterisk__3NGqC"};